"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DatePickerCenterContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _DatePickerCenter = _interopRequireDefault(require("./DatePickerCenter.js"));
var _jsxRuntime = require("react/jsx-runtime");
const DatePickerCenterContainer = props => {
  const {
    days,
    index,
    daysPerWeek,
    cellIndex,
    currentYearMonth,
    maxDate,
    minDate,
    disabledDates,
    today,
    mode,
    selDate,
    selDates,
    sDate,
    eDate,
    setStartDate,
    setEndDate,
    daysColor,
    disabledDaysColor,
    selectedDate,
    onDateChange,
    onChangeDatesHande,
    onChangeStartEndDateHandle,
    borderRadius,
    setSelectedDate,
    calenderBoxShadow,
    calenderBorderWidth,
    calenderBorderStyle,
    calenderBorderColor,
    dateWeekHeight,
    dateWeekWidth,
    dateWeekMargin,
    dateBgColor,
    hoverDateBgColor,
    dateBorderRadius,
    dateBorderWidth,
    dateBorderStyle,
    dateBorderColor,
    dateBoxShadow,
    dateFontFamily,
    dateFontStyle,
    dateFontWeight,
    dateFontSize,
    dateTransformation,
    dateDecoration,
    hoverDateTextColor,
    dateLineHeight,
    disabledDateBgColor,
    disabledDateBorderRadius,
    disabledDateBorderWidth,
    disabledDateBorderStyle,
    disabledDateBorderColor,
    disabledDateBoxShadow,
    disabledDateFontFamily,
    disabledDateFontStyle,
    disabledDateFontWeight,
    disabledDateFontSize,
    disabledDateTransformation,
    disabledDateDecoration,
    disabledDateTextColor
  } = props;
  const day = days[index * daysPerWeek + cellIndex];
  let isEnabled = day.getMonth() == currentYearMonth.getMonth() && day.getFullYear() == currentYearMonth.getFullYear();
  if (day.getTime() > maxDate.getTime() || day.getTime() < minDate.getTime()) {
    isEnabled = false;
  }
  if (disabledDates) {
    for (let el of disabledDates) {
      if (el.getTime() == day.getTime()) {
        isEnabled = false;
        break;
      }
    }
  }

  // let isToday =
  // 	day.getDate() == today.getDate() &&
  // 	day.getMonth() == today.getMonth() &&
  // 	day.getFullYear() == today.getFullYear();

  const todayValue = new Date();
  let isToday = day.getDate() == todayValue.getDate() && day.getMonth() == todayValue.getMonth() && day.getFullYear() == todayValue.getFullYear();
  let isSelected = false;
  let isRange = false;
  switch (mode) {
    case 'date':
      isSelected = selDate?.getTime() == day.getTime();
      break;
    case 'dates':
      if (selDates) {
        for (let el of selDates) {
          if (el.getTime() == day.getTime()) {
            isSelected = true;
            break;
          }
        }
      }
      break;
    case 'range':
      isSelected = sDate?.getTime() == day.getTime() || eDate?.getTime() == day.getTime();
      if (sDate && eDate) {
        isRange = day.getTime() < eDate.getTime() && day.getTime() > sDate.getTime();
      }
      break;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DatePickerCenter.default, {
    day: day,
    sDate: sDate,
    eDate: eDate,
    setStartDate: setStartDate,
    setEndDate: setEndDate,
    isToday: isToday,
    isEnabled: isEnabled,
    isSelected: isSelected,
    isRange: isRange,
    daysColor: daysColor,
    disabledDaysColor: disabledDaysColor,
    mode: mode,
    selectedDate: selectedDate,
    selDate: selDate,
    setSelectedDate: setSelectedDate,
    onDateChange: onDateChange,
    onChangeDatesHande: onChangeDatesHande,
    onChangeStartEndDateHandle: onChangeStartEndDateHandle,
    borderRadius: borderRadius,
    calenderBoxShadow: calenderBoxShadow,
    calenderBorderWidth: calenderBorderWidth,
    calenderBorderStyle: calenderBorderStyle,
    calenderBorderColor: calenderBorderColor,
    dateWeekHeight: dateWeekHeight,
    dateWeekWidth: dateWeekWidth,
    dateWeekMargin: dateWeekMargin,
    dateBgColor: dateBgColor,
    hoverDateBgColor: hoverDateBgColor,
    dateBorderRadius: dateBorderRadius,
    dateBorderWidth: dateBorderWidth,
    dateBorderStyle: dateBorderStyle,
    dateBorderColor: dateBorderColor,
    dateBoxShadow: dateBoxShadow,
    dateFontFamily: dateFontFamily,
    dateFontStyle: dateFontStyle,
    dateFontWeight: dateFontWeight,
    dateFontSize: dateFontSize,
    dateTransformation: dateTransformation,
    dateDecoration: dateDecoration,
    hoverDateTextColor: hoverDateTextColor,
    dateLineHeight: dateLineHeight,
    disabledDateBgColor: disabledDateBgColor,
    disabledDateBorderRadius: disabledDateBorderRadius,
    disabledDateBorderWidth: disabledDateBorderWidth,
    disabledDateBorderStyle: disabledDateBorderStyle,
    disabledDateBorderColor: disabledDateBorderColor,
    disabledDateBoxShadow: disabledDateBoxShadow,
    disabledDateFontFamily: disabledDateFontFamily,
    disabledDateFontStyle: disabledDateFontStyle,
    disabledDateFontWeight: disabledDateFontWeight,
    disabledDateFontSize: disabledDateFontSize,
    disabledDateTransformation: disabledDateTransformation,
    disabledDateDecoration: disabledDateDecoration
  });
};
exports.DatePickerCenterContainer = DatePickerCenterContainer;
var _default = exports.default = DatePickerCenterContainer;